import React, {useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';

import "../Pagina.css";
import "../content-styles.css"

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
	reqGET,
	reqPUT,
    passwordHash

} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import Loader from '../../../loader'

import Navbar from "../Navbar/Navbar_00";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer_00";

import { language } from './Language';

export default function Perfil(props) {
    const [, set_dados] = useState(null);
    const is_logged_in = useRef(null);

    const user_info = useRef({});
      
    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

	const [isloading, setLoading] = useState(true)
    const [isRedirect, setRedirect] = useState(false)

    const [lang, set_lang] = useState('pt');

    const [pwd, set_pwd] = useState('');
    const [new_pwd, set_new_pwd] = useState('');
    const [new_pwd_conf, set_new_pwd_conf] = useState('');

    const [agree, setAgree] = useState(false);
    
    useEffect(() => {

        (async () => {
            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)

            if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {
                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }

            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }

            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }

            let getClientInfo = async (id_user) => {
                return await reqGET(`${Hosts.SIMCore_API}/entities/${Hosts.companycode}/${id_user}`)
                    .then(res => {
                        console.log('set_user_info', res.data[0])

                        set_dados(user_info.current = res.data[0])
                        // set_dados(user_info.current.notifications = [])

                        setAgree(res.data[0].info.marketing)

                        setLoading(false)
                    })
                    .catch(erro => console.log(erro))
            }
            if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {
                getClientInfo(token_info.user_info.id)
            }
            else {
                setRedirect(true)
            }
        })()

        if(localStorage.getItem('lang') !== undefined  || localStorage.getItem('lang') !== null) {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props]);

    const handleSubmit = async (e) => {
		e.preventDefault();

        console.log('user_info', user_info)

        if(user_info.current.info.name === '') {

            Swal.fire('', language[lang].name_error, 'info')
            return
        }
        if(user_info.current.info.email === '') {

            Swal.fire('', language[lang].email_error, 'info')
            return

        }

        if(new_pwd !== '') {
            let pwd_hash = passwordHash(pwd)
            if(pwd_hash === user_info.current.info.password) {

                if(new_pwd === new_pwd_conf) {
                    let npwd = passwordHash(new_pwd)
                    user_info.current.info.password = npwd

                }
                else {
                    Swal.fire('', language[lang].pwd_error, 'info')
                    return
                }

            }
            else {
                Swal.fire('', language[lang].old_pwd_error, 'info')
                return
            }
        }

        await reqPUT(`${Hosts.SIMCore_API}/entities`, user_info.current)

        Swal.fire('', language[lang].perfil_upadate_success, 'info')

	}

    const handle_change_info_documento_userinfo = (e) => {
        const { name, value } = e.target;

        if(name === 'email') {
            set_dados(user_info.current.info['username'] = value)
        }

        set_dados(user_info.current.info[name] = value)


    }

    const handle_change_info_documento_userinfo_addresses = (e) => {
        const { name, value } = e.target;

        set_dados(user_info.current.addresses[0][name] = value)

    }

    const handle_change_info_documento_userinfo_contacts = (e) => {
        const { name, value } = e.target;

        if (name === 'email')
            set_dados(user_info.current.info[name] = value)

        set_dados(user_info.current.contacts[0][name] = value)

    }

    const checkboxHandler = () => {
      // if agree === true, it will be set to false
      // if agree === false, it will be set to true
      setAgree(!agree);
      // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (value) => {
        //console.log('AGREE', agree)
        if (value === true)
            return true
        else 
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
    } 

    const handle_change_pwd = (e) => {
        const { name, value } = e.target;

        if(name === 'pwd') {
            set_pwd(value)
        }
        else 
        if(name === 'new_pwd') {
            set_new_pwd(value)
        }
        else if(name === 'new_pwd_conf') {
            console.log('conf')
            set_new_pwd_conf(value)
        }

    }

    return (
        isRedirect ? 
            <Redirect to={'/'} replace />
        :
        isloading ?
            <Loader />
        :
        <>
            <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />

            <Breadcrumb /> 

            <div className="container-fluid mb-5">
                <div className="row">
                    <div className='col-12 bg-light py-5'>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12 col-lg-10'>
                                    <h3 className="titulo-primario">
                                        <span>{language[lang].dados_pessoais}</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="container">
                                <div className='row'>
                                    <div className='col-12 col-lg-10 mx-auto mt-5'>
                                        <div className="row mb-3">
                                            <div className="col-8">
                                                <label className="form-label">{language[lang].dados_nome} (*)</label>
                                                <input type="text" name="name" className="form-control rounded-0" placeholder="" value={user_info.current.info.name} onChange={handle_change_info_documento_userinfo} />
                                            </div>

                                            <div className="col-4">
                                                <label className="form-label">{language[lang].dados_vat}</label>
                                                <input type="text" name="vat" className="form-control rounded-0" placeholder="" value={user_info.current.info.vat} onChange={handle_change_info_documento_userinfo} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-8">
                                                <label className="form-label">{language[lang].dados_email} (*)</label>
                                                <input type="email" name="email" className="form-control rounded-0" placeholder="" value={(user_info.current.contacts[0].email !== '' ? user_info.current.contacts[0].email : user_info.current.info.email)} onChange={handle_change_info_documento_userinfo_contacts} />
                                            </div>

                                            <div className="col-4">
                                                <label className="form-label">{language[lang].dados_mobile_phone}</label>
                                                <input type="text" name="mobile_phone" className="form-control rounded-0" placeholder="" value={user_info.current.contacts[0].mobile_phone} onChange={handle_change_info_documento_userinfo_contacts} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-8">
                                                <label className="form-label">{language[lang].dados_morada}</label>
                                                <textarea type="text" rows="4" name="address_detail" className="form-control rounded-0" placeholder="" value={user_info.current.addresses[0].address_detail} onChange={handle_change_info_documento_userinfo_addresses} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <label className="form-label">{language[lang].dados_codigo_postal}</label>
                                                <input type="text" name="postal_code" className="form-control rounded-0" placeholder="" value={user_info.current.addresses[0].postal_code} onChange={handle_change_info_documento_userinfo_addresses} />
                                            </div>
                                            <div className="col-4">
                                                <label className="form-label">{language[lang].dados_localidade}</label>
                                                <input type="text" name="localidade" className="form-control rounded-0" placeholder="" value={user_info.current.addresses[0].localidade} onChange={handle_change_info_documento_userinfo_addresses} />
                                            </div>
                                            <div className="col-4">
                                                <label className="form-label">{language[lang].dados_pais}</label>
                                                <input type="text" name="country" className="form-control rounded-0" placeholder="" value={user_info.current.addresses[0].country} onChange={handle_change_info_documento_userinfo_addresses} />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <input type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)} />
                                                <label className="ps-3" htmlFor="agree">{language[lang].agree_marketing}</label>

                                                <label className="pt-3 small" htmlFor="agree">{language[lang].terms_conditions_required}</label>
                                            </div>
                                        </div>


                                        <div className='mt-5'>
                                            <div className="my-3">
                                                <h3 className="titulo-secundario">{language[lang].dados_acesso}</h3>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-4">
                                                    <label className="form-label">{language[lang].pwd}</label>
                                                    <input type="password" name="pwd" className="form-control rounded-0" placeholder="" value={pwd} onChange={handle_change_pwd} />
                                                </div>
                                                <div className="col-4">
                                                    <label className="form-label">{language[lang].new_pwd}</label>
                                                    <input type="password" name="new_pwd" className="form-control rounded-0" placeholder="" value={new_pwd} onChange={handle_change_pwd} />
                                                </div>

                                                <div className="col-4">
                                                    <label className="form-label">{language[lang].new_pwd_conf}</label>
                                                    <input type="password" name="new_pwd_conf" className="form-control rounded-0" placeholder="" defaultValue={new_pwd_conf} onBlur={handle_change_pwd} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='text-end mt-5'>
                                            <button className="btn btn-secondary px-4" onClick={handleSubmit}> {language[lang].salvar} </button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
        </>

    );
}

